import React from 'react'

export type EventInfoProps = {
  headline: string
  text: string
  url: string
}

export default function EventInfo(props: EventInfoProps) {
  return (
    <div className="ModalEventInfo">
      <div className="ModalEventInfo__HeadlineContainer">
        <div className="ModalEventInfo__Headline">Sonderveranstaltung</div>
      </div>
      <div className="ModalEventInfo__Subline">{props.headline}</div>
      <div className="ModalEventInfo__Text Text Text--center">{props.text}</div>
      <div className="ModalEventInfo__Cta">
        <a
          href={props.url}
          target="_blank"
          className="Cta Cta--icon Cta--icon-ticket"
          rel="noreferrer"
        >
          {window.jsProps.strings.bookTickets}
        </a>
      </div>
    </div>
  )
}
